var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoldRemediationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "26px",
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.179035294 16.2547412 0.179035294 16.2547412 16.4338588 0 16.4338588"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0932647059 0.145023529 7.57605882 0.145023529 7.57605882 7.62761176 0.0932647059 7.62761176"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mold-Remediation",
    transform: "translate(-48.000000, -254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(48.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 6.594824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-mold-remediation-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12732941,0.179035294 C12.6159765,0.179035294 16.2547412,3.8178 16.2547412,8.30644706 C16.2547412,12.7950941 12.6159765,16.4338588 8.12732941,16.4338588 C3.63868235,16.4338588 -8.23529412e-05,12.7950941 -8.23529412e-05,8.30644706 C-8.23529412e-05,3.8178 3.63868235,0.179035294 8.12732941,0.179035294",
    id: "Fill-1",
    fill: "#FBFBFD",
    mask: "url(#mask-mold-remediation-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.12732941,4.11764706e-05 C10.7148588,4.11764706e-05 12.8119765,2.09757059 12.8119765,4.68468824 C12.8119765,7.27180588 10.7148588,9.36933529 8.12732941,9.36933529 C5.54021176,9.36933529 3.44268235,7.27180588 3.44268235,4.68468824 C3.44268235,2.09757059 5.54021176,4.11764706e-05 8.12732941,4.11764706e-05",
    id: "Fill-4",
    fill: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0969294,22.5513647 C22.0345176,22.5513647 22.7950471,23.3118941 22.7950471,24.2494824 C22.7950471,25.1874824 22.0345176,25.9476 21.0969294,25.9476 C20.1589294,25.9476 19.3988118,25.1874824 19.3988118,24.2494824 C19.3988118,23.3118941 20.1589294,22.5513647 21.0969294,22.5513647",
    id: "Fill-6",
    fill: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2506647,6.07435294 C24.1882529,6.07435294 24.9483706,6.83447059 24.9483706,7.77205882 C24.9483706,8.70964706 24.1882529,9.46976471 23.2506647,9.46976471 C22.3130765,9.46976471 21.5529588,8.70964706 21.5529588,7.77205882 C21.5529588,6.83447059 22.3130765,6.07435294 23.2506647,6.07435294",
    id: "Fill-8",
    fill: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(20.176471, 7.418353)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-mold-remediation-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83455882,0.145023529 C5.90120588,0.145023529 7.57626471,1.82008235 7.57626471,3.88631765 C7.57626471,5.95255294 5.90120588,7.62761176 3.83455882,7.62761176 C1.76832353,7.62761176 0.0932647059,5.95255294 0.0932647059,3.88631765 C0.0932647059,1.82008235 1.76832353,0.145023529 3.83455882,0.145023529",
    id: "Fill-10",
    fill: "#FBFBFD",
    mask: "url(#mask-mold-remediation-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2430588,4.73109412 C18.3840588,4.73109412 19.3088824,5.65632941 19.3088824,6.79691765 C19.3088824,7.93791765 18.3840588,8.86274118 17.2430588,8.86274118 C16.1020588,8.86274118 15.1772353,7.93791765 15.1772353,6.79691765 C15.1772353,5.65632941 16.1020588,4.73109412 17.2430588,4.73109412",
    id: "Fill-13",
    fill: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9481588,16.5858412 C23.0728647,16.5858412 24.7956882,18.3082529 24.7956882,20.4333706 C24.7956882,22.5580765 23.0728647,24.2809 20.9481588,24.2809 C18.8234529,24.2809 17.1006294,22.5580765 17.1006294,20.4333706 C17.1006294,18.3082529 18.8234529,16.5858412 20.9481588,16.5858412",
    id: "Fill-15",
    fill: "#FBFBFD"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldRemediationIcon);
export default __webpack_public_path__ + "static/media/mold_remediation_icon.f1e5c75c.svg";
export { ForwardRef as ReactComponent };